import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4fb840b4")

_pushScopeId("data-v-4fb840b4")
const _hoisted_1 = { class: "document-label" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-flex-row p-ai-center"
}
const _hoisted_3 = { class: "kn-flex" }
const _hoisted_4 = { class: "info-value" }
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-row p-ai-center"
}
const _hoisted_6 = { class: "kn-flex" }
const _hoisted_7 = { class: "info-value" }
const _hoisted_8 = {
  key: 2,
  class: "p-d-flex p-flex-row p-ai-center"
}
const _hoisted_9 = { class: "kn-flex" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = {
  key: 3,
  class: "p-d-flex p-flex-row p-ai-center"
}
const _hoisted_12 = { class: "kn-flex" }
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = {
  key: 4,
  class: "p-d-flex p-flex-row p-ai-center"
}
const _hoisted_15 = { class: "kn-flex" }
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = { class: "p-d-flex p-flex-row p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.schedulerTimingOutputInfoDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.schedulationInformations')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      (_ctx.info)
        ? (_openBlock(), _createBlock(_component_TabView, { key: 0 }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info.documents, (document, index) => {
                return (_openBlock(), _createBlock(_component_TabPanel, { key: index }, {
                  header: _withId(() => [
                    _createVNode("span", _hoisted_1, _toDisplayString(document.label), 1)
                  ]),
                  default: _withId(() => [
                    (document.mailtos)
                      ? (_openBlock(), _createBlock("div", _hoisted_2, [
                          _createVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('managers.scheduler.mailTo')) + ":", 1),
                          _createVNode("p", _hoisted_4, _toDisplayString(document.mailtos), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (document.zipMailName)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, [
                          _createVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('managers.scheduler.attachedZip')) + ":", 1),
                          _createVNode("p", _hoisted_7, _toDisplayString(document.zipMailName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (document.mailsubj)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t('managers.scheduler.mailSubject')) + ":", 1),
                          _createVNode("p", _hoisted_10, _toDisplayString(document.mailsubj), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (document.containedFileName)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('managers.scheduler.containedFileName')) + ":", 1),
                          _createVNode("p", _hoisted_13, _toDisplayString(document.containedFileName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (document.mailtxt)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t('managers.scheduler.mailText')) + ":", 1),
                          _createVNode("p", _hoisted_16, _toDisplayString(document.mailtxt), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})